import React from 'react';
import SmallInfoIcon from '../assets/images/InfoISmallcon.svg';

export default () => {
  return <img src={SmallInfoIcon} alt="Information" />;
};
